module.exports = __webpack_public_path__ + "static/media/profile-pic.9163ef8f.jpg";